import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { FormChange } from "@saleor/hooks/useForm";
import { onEnterPress } from "@saleor/utils/handlers/OnPressEnter";
import * as React from "react";

interface DropOffTextInputProps {
  onCreate: (name: string) => void;
  change: FormChange;
  name: string;
  value: string;
  disabled?: boolean;
  placeHolder?: string;
  buttonDisabled?: boolean;
}

const DropOffTextInput: React.FC<DropOffTextInputProps> = props => {
  const {
    onCreate,
    change,
    name,
    value,
    disabled = false,
    buttonDisabled = false,
    placeHolder = "Add Another"
  } = props;

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel htmlFor="outlined-adornment-password">
          {placeHolder}
        </InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          type="text"
          labelWidth={70}
          onChange={change}
          name={name}
          disabled={disabled}
          value={value}
          onKeyDown={keypress => onEnterPress(keypress, () => onCreate(value))}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => onCreate(value)}
                edge="end"
                disabled={buttonDisabled}
              >
                <AddCircleIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </div>
  );
};

export default DropOffTextInput;
